import { ValidationState } from "../Types";

export const reactSelectStyles = (validationState?: ValidationState) => {
    return {
        control: (base: any, state: any) => ({
            ...base,
            outline: state.isFocused ? "-webkit-focus-ring-color auto 1px" : "none",
            backgroundColor: state.isFocused ? "white" : "whitesmoke",
            boxShadow: "none",
            outlineOffset: "0px",
            borderRadius: "4px",
            border: validationState === "invalid" ? "solid #d60000" : "none",
            fontFamily: "'Fira Sans', sans-serif",
            ...(state.isDisabled && {
                pointerEvents: "auto",
                cursor: "not-allowed",
                opacity: "0.3",
            }),
            color: 'black'
        }),
        menu: (base: any) => ({ ...base, zIndex: 9999 }),
        input: (base: any) => ({
            ...base,
            maxWidth: "100% !important",
            minHeight: "3rem",
            fontSize: "16px",
            padding: "0",
            margin: "0",
            color: 'black',
            fontWeight: 400
        }),
        singleValue: (base: any) => ({
            ...base,
            color: 'black',
            fontWeight: 400
        }),
        option: (base: any) => ({
            ...base,
            color: 'black',
            fontWeight: 400
        })
    }
};